import React from "react";
import { BaseChunk } from "./ChunkMethodsBase";
import { SaveStatus } from "./SaveStatus";
import { ChunkButtons } from "./ChunkButtons";

export class ListChunk extends BaseChunk {
  displayName = "ListChunk";

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.myInputRef = new Map();
  }

  getInitialState() {
    const value = this.props.model[this.props.field];
    const label = this.props.label != null ? this.props.label : value;
    // this.props.model.on("change:saveStatus change:order_index", () => {
    //   if (this.isMounted()) {
    //     return this.forceUpdate();
    //   }
    // });
    return {
      label:
        this.props.label != null
          ? this.props.label
          : this.capitalizeFirstLetter(label),
      content: this.inputToMarkdown(value),
      bullets: [],
      isEditing: false,
      rawContent: value,
      curIndex: 0,
    };
  }

  isEditing() {
    return this.state.isEditing;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isEditing) {
      this.myInputRef.get(this.state.curIndex).focus();
      if (this.resizePending) {
        delete this.resizePending;
        this.resizeAllEditors();
      }
    }
    if (this.state.isEditing && !prevState.isEditing) {
      return document.body.addEventListener("click", this.onDocumentClick);
    } else if (!this.state.isEditing && prevState.isEditing) {
      return document.body.removeEventListener("click", this.onDocumentClick);
    }
  }

  onDocumentClick = (event) => {
    // Check if click is from a textarea
    const eventIsFromRef = Array.from(this.myInputRef.values()).some(
      (value) => value === event.target,
    );

    // Check if click is from a delete button
    const isDeleteButton = event.target.closest(".delete-bullet");

    if (!eventIsFromRef && !isDeleteButton) {
      return this.closeEditor(true);
    }
  };

  resizeAllEditors() {
    var i, results;
    results = [];
    for (i in this.state.bullets) {
      results.push(this.resizeEditor(this.myInputRef.get(Number(i))));
    }
    return results;
  }

  onKeyDown(index, event) {
    var el, firstBullet, lastBullet;
    switch (event.keyCode) {
      case 13: // enter
        event.preventDefault();
        this.state.bullets.splice(index + 1, 0, "");
        return this.setState({
          bullets: this.state.bullets,
          rawContent: this.state.bullets.join("\n"),
          curIndex: index + 1,
        });
      case 40: // down arrow
        el = document.activeElement;
        if (el.selectionStart === el.selectionEnd) {
          if (el.selectionStart === el.value.length) {
            return this.setState({
              curIndex: Math.min(
                this.state.curIndex + 1,
                this.state.bullets.length - 1,
              ),
            });
          } else {
            return (el.selectionStart = el.selectionEnd = el.value.length);
          }
        }
        break;
      case 38: //up arrow
        el = document.activeElement;
        if (el.selectionStart === el.selectionEnd) {
          if (el.selectionStart === 0) {
            return this.setState({
              curIndex: Math.max(this.state.curIndex - 1, 0),
            });
          } else {
            return (el.selectionStart = el.selectionEnd = 0);
          }
        }
        break;
      case 9: //tab
        firstBullet = this.myInputRef.get(0);
        lastBullet = this.myInputRef.get(this.state.bullets.length - 1);
        if (!event.shiftKey) {
          if (document.activeElement === lastBullet) {
            event.preventDefault();
            return firstBullet.focus();
          }
        } else {
          if (document.activeElement === firstBullet) {
            event.preventDefault();
            return lastBullet.focus();
          }
        }
    }
  }

  onKeyUp(index, event) {
    switch (event.keyCode) {
      case 27: //escape
        this.closeEditor(false);
    }
    return null;
  }

  onBulletFocus(index, event) {
    this.setState({
      isEditing: true,
      curIndex: index,
    });
    return null;
  }

  onBulletChange(index, event) {
    var bullets, newRawContent;
    bullets = this.state.bullets;
    bullets[index] = event.target.value;
    // add another empty input if the last list item isnt empty
    if (index === bullets.length - 1 && event.target.value.length > 0) {
      bullets.push("");
    }
    newRawContent = bullets.join("\n");
    // IE will fire onBulletChange when other browsers don't.
    // This is causing focusing problems.
    // So, if nothing actually changed then abandon execution
    if (this.state.rawContent === newRawContent) {
      return;
    }
    this.setState({
      bullets: bullets,
      rawContent: newRawContent,
    });
    this.resizeEditor(event.target);
    return null;
  }

  deleteBulletClick(index, e) {
    // Prevent the click from bubbling up to document
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    var bullets;
    bullets = this.state.bullets;
    bullets.splice(index, 1);
    // special case - deleted last bullet
    if (bullets.length === 0) {
      bullets.push("");
    }
    this.resizePending = true;
    return this.setState({
      bullets: bullets,
      curIndex: bullets.length - 1,
    });
  }

  startEdit(e) {
    let len;
    // split model content into bullets
    try {
      const txtBullets = this.props.model[this.props.field].split(/^\*\s/gm);
      const bullets = txtBullets.reduce((acc, b) => {
        const bullet = b.trim();
        if (bullet.length > 0) {
          acc.push(bullet);
        }
        return acc;
      }, []);

      // add one at the end
      bullets.push("");
      this.resizePending = true;
      this.setState({
        bullets: bullets,
        isEditing: true,
        curIndex: bullets.length - 1,
      });
    } catch (e) {
      debugger;
    }
    return null;
  }

  closeEditor(save) {
    let newValue = "";
    const ref = this.state.bullets;
    let len;
    for (let j = 0, len = ref.length; j < len; j++) {
      const bullet = ref[j];
      const val = bullet.trim();
      if (val.length) {
        newValue += `* ${this.bbCodeToMarkdown(val)}\n`;
      }
    }

    const update = { bullets: [], isEditing: false };
    if (save) {
      const oldValue = this.props.model[this.props.field];
      if (newValue !== oldValue) {
        // no id, this item is probably still saving
        this.props.model[`${this.props.field}`] = newValue;

        if (this.props.onChange) {
          const { model, field } = this.props;
          this.props.onChange({ model, field });
        }

        update.content = this.inputToMarkdown(newValue);
      }
    }
    return this.setState(update);
  }

  setItemRef(id, element) {
    if (element) {
      this.myInputRef.set(id, element); // Store the ref with a unique ID
    } else {
      this.myInputRef.delete(id); // Remove the ref when the element unmounts
    }
  }

  render() {
    const divClasses =
      "chunk edit list" + (this.state.isEditing ? " active" : "");
    return (
      <div
        ref={this.containerRef}
        className={divClasses}
        data-id={this.props.model.id}
      >
        {this.props.canDelete ? (
          <div className="grab-handle">
            <div>
              <span>drag</span>
            </div>
          </div>
        ) : (
          false
        )}

        <div className="block">
          <h1>{this.state.label}:</h1>
          {this.state.bullets.length == 0 ? (
            <div
              className="chunk-display"
              onFocus={this.startEdit.bind(this)}
              contentEditable="true"
              data-placeholder="Click to enter an item..."
              dangerouslySetInnerHTML={{ __html: this.state.content }}
            ></div>
          ) : null}

          <div className="bullets">
            {this.state.bullets.map(
              function (text, i) {
                return (
                  <div key={i} className="chunk-edit">
                    <textarea
                      ref={(el) => {
                        this.setItemRef(i, el);
                      }}
                      rows="1"
                      placeholder="Add an item..."
                      onFocus={this.onBulletFocus.bind(this, i)}
                      onKeyDown={this.onKeyDown.bind(this, i)}
                      onKeyUp={this.onKeyUp.bind(this, i)}
                      onChange={this.onBulletChange.bind(this, i)}
                      value={text}
                    />
                    <span
                      className="delete-bullet delete-button unselectable"
                      onClick={this.deleteBulletClick.bind(this, i)}
                    >
                      <span className="label">Delete Item</span>
                    </span>
                  </div>
                );
              }.bind(this),
            )}
          </div>
        </div>

        <p className="markdown-help">{this.props.help}</p>
        <ChunkButtons
          model={this.props.model}
          section={this.props.section}
          buttons={this.props.buttons}
          isLastChunk={this.props.isLastChunk}
        />
        <SaveStatus status={this.props.model.saveStatus} />
      </div>
    );
  }
}
